import React, { useState,useEffect,useRef } from "react";
import {
  IonItem,
  IonLabel,
  IonButton,
  IonInput,
  IonToast,
  IonPage,
  IonHeader,
  IonToolbar,
  IonContent,IonButtons, IonBackButton, IonText,IonIcon,
  IonModal,
  IonFab, IonFabButton, IonFabList,
  IonCol, IonGrid, IonRow, IonReorderGroup, IonReorder, IonImg
} from "@ionic/react";

import { MobXProviderContext, observer } from "mobx-react";
import { useHistory } from "react-router";
import * as firebase from "firebase";
import * as icons from 'ionicons/icons';
import IconArray from './IconArray';

const TabEditPage = () => {
  const { store } = React.useContext(MobXProviderContext);
  const history = useHistory();
  const [errorInfo, setErrorInfo] = useState({});
  const [email, setEmail] = useState(null);
  const [otp, setOTP] = useState(null);
  const [password, setPassword] = useState(null);
  const [firstName, setFirstName] = useState(null);
  const [lastName, setLastName] = useState(null);
  const [linkedin, setLinkedin] = useState(null);
  const [signup, setSignup] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [showSave, setShowSave] = useState(false);
  const [iconval, setIconval] = useState('');
  const [newbuttons, setNewbuttons] = useState([{icon:'at',name:'Email',data:''},{icon:'call',name:'Phone',data:''},{icon:'location',name:'Location',data:''},{icon:'person',name:'Name',data:''},{icon:'logoLinkedin',name:'Linkedin',data:''}]);
  const [accountId, setAccountId] = useState(null);
  const [curIdx, setCurIdx] = useState(0);
  const updateIconval = (val,ind) =>{
    let newbuttons1 = newbuttons;
    newbuttons1[ind].data = val;
    setNewbuttons(newbuttons1);
  }
  Array.prototype.move = function (from, to) {
    this.splice(to, 0, this.splice(from, 1)[0]);
  };
  const updateIconname = (val,ind) =>{
    let newbuttons1 = newbuttons;
    newbuttons1[ind].name = val;
    setNewbuttons(newbuttons1);
    setShowSave(true);
  }
  const removeIcon = (ind) =>{
    let newbuttons1 = newbuttons;
    newbuttons1.splice(ind,1);
    setNewbuttons(newbuttons1);
    setShowSave(true);
  }
  const input = useRef(null);
  useEffect(() => {
    setAccountId(window.localStorage.getItem('account_id'));
    if(window.localStorage.getItem('account_id')==null || window.localStorage.getItem('account_id')==undefined || window.localStorage.getItem('account_id')==''){
      if (history.location.pathname=='/tabs/edit') {
        return history.replace("/tabs/settings");
      }
    }
    else{
      let ad = JSON.parse(window.localStorage.getItem('account_data'));
      if(ad){
        console.log(ad)
        setFirstName(ad.name);
        setLastName(ad.phone);
        setEmail(ad.email);
        setPassword(ad?.location);
        setLinkedin(ad?.linkedin);
        if(ad?.newbuttons) setNewbuttons(ad?.newbuttons);
      }
    }
  }, [history.location]);
  const _doCreateAccount = async () => {
    if(email!=null){
      firebase.firestore().collection("accounts").doc(accountId).update({email: email});
    }
    if(firstName!=null){
      firebase.firestore().collection("accounts").doc(accountId).update({name: firstName});
    }
    if(password!=null){
      firebase.firestore().collection("accounts").doc(accountId).update({location: password});
    }
    if(linkedin!=null){
      firebase.firestore().collection("accounts").doc(accountId).update({linkedin: linkedin});
    }
    firebase.firestore().collection("accounts").doc(window.localStorage.getItem('account_id')).update({newbuttons: newbuttons});
    console.log(newbuttons)
    window.localStorage.setItem('account_data',JSON.stringify({email:email,name:firstName,location:password,linkedin:linkedin,phone:lastName,newbuttons:newbuttons}));
    setErrorInfo({ showErrorToast: true, errMsg: 'Data saved successfully!' });
    setShowSave(false);
  };
  const confirm = (val) => {
    // setIconval();
    let newbtn = newbuttons;
    // newbuttons.push({icon:val,data:''});
    newbuttons[curIdx]['icon']=val;
    setNewbuttons(newbuttons);
    setShowAlert(false);
    setShowSave(true);
  }
  const addNewRow = () =>{
    setNewbuttons([...newbuttons,{icon:'aperture',name:'Title',data:''}]);
    setShowSave(true);
  }
  const onWillDismiss = (ev)=>{
    if (ev.detail.role === 'confirm') {
      
    }
  }
  const handleReorder = (event) =>{
    console.log('Dragged from index', event.detail.from, 'to', event.detail.to);
    // let arr = newbuttons;
    // arr.move(event.detail.from,event.detail.to);
    // setNewbuttons(arr);console.log(arr)
      const from = event.detail.from;
    const to = event.detail.to;

    // Create new array with reordered items
    let newArr = [...newbuttons];
    const moved = newArr.splice(from, 1)[0];
    newArr.splice(to, 0, moved);
console.log(newArr)
    setNewbuttons([...newArr]);
    event.detail.complete(newArr);
    setShowSave(true);
  }
  const chooseIcon = (idx) => {
    setCurIdx(idx);
    setShowAlert(true);
  }
  return (
    <IonPage>
      <IonContent className="ion-padding">
        <IonModal className="iconmodal" isOpen={showAlert} onWillDismiss={(ev) => onWillDismiss(ev)}>
          <IonContent className="ion-padding noscroll">
          <div className="iconlist">
            {IconArray.map(function(d, idx){
              return <IonIcon key={'m'+idx} onClick={()=>confirm(d)} icon={icons[d]}></IonIcon>
            })}
          </div>
          </IonContent>
        </IonModal>
        <div className="logo"><IonImg src="/assets/img/logo.png" alt="Logo"></IonImg></div>
        <IonText style={{'textAlign':'center'}}><h4>Shortcuts</h4></IonText>
        <IonText style={{'textAlign':'center'}}><p>You can add up to 10 shortcuts</p></IonText>
        {/*<IonItem style={{'marginBottom':'5px'}}>
          <IonIcon icon={icons['card']} style={{'position': 'absolute', 'right': '30px'}}></IonIcon><IonInput
            type="text"
            onIonChange={(e) => {
              setFirstName(e.detail.value);
            }}
            name="name"
            placeholder="Name"
            value={firstName}
          />
        </IonItem>
        <IonItem style={{'marginBottom':'5px'}}>
          <IonIcon icon={icons['at']} style={{'position': 'absolute', 'right': '30px'}}></IonIcon><IonInput
            type="email"
            onIonChange={(e) => {
              setEmail(e.detail.value);
            }}
            name="email"
            placeholder="Email Address"
            value={email}
          />
        </IonItem>
        <IonItem style={{'marginBottom':'5px'}}>
          <IonIcon icon={icons['logoLinkedin']} style={{'position': 'absolute', 'right': '30px'}}></IonIcon><IonInput
            type="text"
            onIonChange={(e) => {
              setLinkedin(e.detail.value);
            }}
            name="lastname"
            placeholder="LinkedIn"
            value={linkedin}
          />
        </IonItem>
        <IonItem style={{'marginBottom':'5px'}}>
          <IonIcon icon={icons['location']} style={{'position': 'absolute', 'right': '30px'}}></IonIcon><IonInput
            type="text"
            onIonChange={(e) => {
              setPassword(e.detail.value);
            }}
            name="location"
            placeholder="Location"
            value={password}
          />
        </IonItem>*/}
        <IonGrid className="icongrid">
          <IonReorderGroup disabled={false} onIonItemReorder={handleReorder}>
          {newbuttons.map(function(d, idx){
            return (<IonRow key={'si'+idx}>
            <IonCol size="1"><IonIcon onClick={()=>chooseIcon(idx)} icon={icons[d.icon]}></IonIcon></IonCol>
            <IonCol size="4">
              <IonItem>
                <IonInput onIonChange={(e) => {
                  updateIconname(e.detail.value,idx);
                }} type="text" placeholder="Title" value={d?.name} />
              </IonItem>
            </IonCol>
            <IonCol size="5">
              <IonItem>
                <IonInput onIonChange={(e) => {
                  updateIconval(e.detail.value,idx);
                }} type="text" placeholder="Value" value={d?.data} />
              </IonItem>
            </IonCol>
            <IonCol size="1" style={{'padding-top':'12px'}}>
              <IonReorder></IonReorder>
            </IonCol>
            <IonCol size="1">
              <IonIcon onClick={()=>removeIcon(idx)} icon={'close'}></IonIcon>
            </IonCol>
          </IonRow>) 
          })}
          </IonReorderGroup>
        </IonGrid>
        {/*newbuttons.map(function(d, idx){
           return (<IonItem key={'si'+idx} style={{'marginBottom':'5px'}}>
          <IonIcon icon={icons[d.icon]} style={{'position': 'absolute', 'right': '30px'}}></IonIcon><IonInput
            type="text"
            onIonChange={(e) => {
              updateIconval(e.detail.value,idx);
            }}
            value={d.data}
          />
        </IonItem>) })*/}
        {<div style={{ padding: 8 }}>
          <IonButton
            expand="full"
            style={{ margin: 14 }}
            onClick={(e) => {
              if (!e.currentTarget) {
                return;
              }
              e.preventDefault();
              _doCreateAccount(history);
            }}
          >
            Save
          </IonButton>
        </div>}
        <IonToast
          color="success"
          isOpen={errorInfo.showErrorToast}
          onDidDismiss={() => setErrorInfo({ showErrorToast: false })}
          message={errorInfo.errMsg}
          duration={2000}
          position="middle"
        />
        {newbuttons.length<10?<IonFab slot="fixed" vertical="bottom" horizontal="end">
          <IonFabButton onClick={()=>addNewRow()}>
            <IonIcon icon={icons['add']}></IonIcon>
          </IonFabButton>
        </IonFab>:null}
      </IonContent>
    </IonPage>
  );
};

export default TabEditPage;
